import React from 'react';
import { motion } from 'framer-motion';
import { Moon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    day: 'Día 1-2',
    title: 'Preparación',
    desc: 'Ajustas el ambiente y estableces el ritual de 15 minutos.'
  }, {
    day: 'Día 3-5',
    title: 'Transición',
    desc: 'Implementas la escalera de retiro gradual (de la mano a la voz).'
  }, {
    day: 'Día 6-7',
    title: 'Independencia',
    desc: 'Tu bebé conecta ciclos de sueño y tú recuperas tus horas de descanso.'
  }];
  return <section className="py-24 bg-navy text-cream relative overflow-hidden" data-id="element-53">
      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-56">
            Cómo funciona
          </h2>
          <div className="w-16 h-px bg-amber mx-auto" data-id="element-57"></div>
        </motion.div>

        <div className="relative" data-id="element-58">
          {/* Vertical line for desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-amber/20 -translate-x-1/2" data-id="element-59"></div>

          <div className="space-y-12 md:space-y-24" data-id="element-60">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className={`flex flex-col md:flex-row items-center ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-61">
                <div className="md:w-1/2 flex justify-center md:justify-start md:px-12 mb-8 md:mb-0 w-full" data-id="element-62">
                  <div className={`bg-cream/5 p-8 rounded-2xl border border-amber/10 w-full max-w-sm ${index % 2 === 0 ? 'md:ml-auto' : 'md:mr-auto'}`} data-id="element-63">
                    <span className="text-amber font-serif text-xl mb-2 block" data-id="element-64">
                      {step.day}
                    </span>
                    <h4 className="text-2xl font-medium mb-4" data-id="element-65">{step.title}</h4>
                    <p className="text-cream/70 leading-relaxed" data-id="element-66">{step.desc}</p>
                  </div>
                </div>

                {/* Center node */}
                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-12 h-12 bg-navy border-2 border-amber rounded-full items-center justify-center z-10" data-id="element-67">
                  <Moon className="w-5 h-5 text-amber" data-id="element-68" />
                </div>

                <div className="md:w-1/2" data-id="element-69"></div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}